import React from 'react';
import { useI18n } from 'nordic/i18n';
import TrackingLink from '../../../../../components/TrackingLink';
import SharedPropsContext from '../../../../../contexts/SharedProps';
import { getDisclaimerSectionContent } from '../../content/disclaimerSection';
import DisclaimerSale from '../DisclaimerSale';

const DisclaimerSection = () => {
  const {
    helpLinks,
    tracks,
  } = React.useContext(SharedPropsContext);

  const { i18n } = useI18n();

  const {
    moreInfo: {
      question,
      helpText,
      endText,
    },
  } = getDisclaimerSectionContent({ i18n });

  const helpLink = (
    <TrackingLink
      href={helpLinks.mercadoCredito}
      target="_blank"
      trackInfo={tracks.analytics.events.buyersPage.disclaimerSection.goToHelp}
      trackInfoMelidata={tracks.melidata.events.buyersPage.disclaimerSection.goToHelp}
    >
      {helpText}
    </TrackingLink>
  );

  return (
    <section className="disclaimer-section">
      <div className="disclaimer-section__more-info">{question} {helpLink}{endText}</div>
      <DisclaimerSale />
    </section>
  );
};

export default DisclaimerSection;
